<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CAjQk0/tc-custom/9783985313013.jpg?1703042118653" alt="This image is the cover for the book The Life and Letters of Lafcadio Hearn Volume I & II, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Life and Letters of Lafcadio Hearn Volume I & II, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Excerpt: "In the course of the preparation of these volumes there was gradually accumulated so great a number of the letters written by Lafcadio Hearn during twenty-five years of his life, and these letters proved of so interesting a nature, that eventually the plan of the whole work was altered. The original intention was that they should serve only to illuminate the general text of the biography, but as their number and value became more apparent it was evident that to reproduce them in full would make the book both more readable and more illustrative of the character of the man than anything that could possibly be related of him. No biographer could have so vividly pictured the modesty and tender-heartedness, the humour and genius of the man as he has unconsciously revealed these qualities in unstudied communications to his friends. Happily—in these days when the preservation of letters is a rare thing—almost every one to whom he wrote appeared instinctively to treasure—even when he was still unknown—every one of his communications, though here and there regrettable gaps occur, owing to the accidents of changes of residence, three of which, as every one knows, are more destructive of such treasures than a fire. To all of his correspondents who have so generously contributed their treasured letters I wish to express my sincere thanks. Especially is gratitude due to Professor Masanubo Otani, of the Shinshu University of Tōkyō, for the painstaking accuracy and fulness of the information he contributed as to the whole course of Hearn’s life in Japan."</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elizabeth Bisland
      </h2>
      
      <p class="authorDescription body article">Elizabeth Bisland Wetmore (February 11, 1861 – January 6, 1929) was an American journalist and author, perhaps now best known for her 1889–1890 race around the world against Nellie Bly, which drew worldwide attention. The majority of her writings were literary works. She published all of her works as Elizabeth Bisland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f1b7bf34